<script setup lang="ts">
const menuItems = computed<Array<MenuItem>>(() => [{
  title: 'Kontakt',
  path: '/contact',
  show: true
}]);
const open = ref<boolean>(false);
const openList = ref<Object>({});
</script>

<template>
  <header>
    <nav class="navbar">
      <div id="logo">
        <div class="flex flex-row items-center gap-6">
          <NuxtLink href="/" class="scale-100 hover:scale-[1.05] ease-in duration-200">
            <svg
              xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
              width="155" height="55"
              viewBox="0 0 313.19 107.59"
              fill="none"
              aria-hidden="true" role="img">
              <path class="fill-none"
                d="M307.35,0a5.84,5.84,0,1,1-5.84,5.84A5.84,5.84,0,0,1,307.35,0ZM312,5.84a4.66,4.66,0,1,0-4.66,4.66A4.66,4.66,0,0,0,312,5.84Z" />
              <path class="fill-none"
                d="M308.38,5.9l.3.14a1.52,1.52,0,0,1,.52.55c.13.22.25.45.36.67l.71,1.43,0,.07H308.7a.09.09,0,0,1-.1-.06l-.75-1.52a2.75,2.75,0,0,0-.17-.29.89.89,0,0,0-.73-.43h-.58v2.3h-1.58V2.65h2.67a3.15,3.15,0,0,1,1.14.2,1.37,1.37,0,0,1,.79.72,2,2,0,0,1,.13.91,1.54,1.54,0,0,1-.17.66,1.45,1.45,0,0,1-.78.68Zm-2-.53h.71a1.66,1.66,0,0,0,.32,0,.63.63,0,0,0,.53-.48,1.23,1.23,0,0,0,0-.54.58.58,0,0,0-.39-.45.85.85,0,0,0-.22,0c-.31,0-.63,0-.94,0h0Z" />
              <path class="fill-primary"
                d="M171,20.8A34.91,34.91,0,0,0,156.13,5.85,46.36,46.36,0,0,0,134.67,1,46.56,46.56,0,0,0,109,8.14a43.11,43.11,0,0,0-10.23,9.11,31,31,0,0,0-8.84-9.11A42.8,42.8,0,0,0,65.43,1,44.16,44.16,0,0,0,43.3,6.62a37.2,37.2,0,0,0-8.77,6.87V2.71H0V105.88H36.24V54.68q0-8,2.39-13a16.93,16.93,0,0,1,6.48-7.52,17.92,17.92,0,0,1,9.44-2.47q7.44,0,11.55,5t4.1,16.08v53.11h36.24V54.68q0-8,2.29-13a16.18,16.18,0,0,1,6.48-7.52,18.08,18.08,0,0,1,9.35-2.47q7.24,0,11.45,5t4.19,16.08v53.11h36.24v-59Q176.44,30.88,171,20.8Z" />
              <path class="fill-secondary"
                d="M253.5,107.59q-17.16,0-30.61-6.85A52.55,52.55,0,0,1,201.81,81.8a50.75,50.75,0,0,1-7.63-27.69q0-15.61,7.63-27.6A52,52,0,0,1,222.89,7.76Q236.33,1,253.5,1,271,1,283.83,8.42A41.16,41.16,0,0,1,302,29.36l-28,14.28q-3.63-7.23-9-10.57a21.58,21.58,0,0,0-11.64-3.33,23.13,23.13,0,0,0-11.44,2.86,20.35,20.35,0,0,0-8.11,8.28,27.29,27.29,0,0,0-2.95,13.23,28.31,28.31,0,0,0,2.95,13.51A20.22,20.22,0,0,0,241.87,76a23.13,23.13,0,0,0,11.44,2.86A21.58,21.58,0,0,0,265,75.52q5.34-3.33,9-10.57l28,14.28a41.16,41.16,0,0,1-18.13,20.94Q271.05,107.6,253.5,107.59Z" />
              <!-- ART AUTHOR: fadrulinik@gmail.com -->
            </svg>
          </NuxtLink>
          <NuxtLink href="/" class="hidden md:block">
            <svg
              xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
              width="342" height="36"
              viewBox="0 0 1069.88 112"
              fill="fill-black"
              aria-hidden="true" role="img">
              <polygon points="104.85 8.04 72.02 63.46 38.25 8.04 15.91 8.04 15.91 103.96 40.97 103.96 40.97 54.49 65.52 94.51 77.58 94.51 102.31 53.08 102.55 103.96 127.47 103.96 127.2 8.04 104.85 8.04"/>
              <path d="M177.5,8,135.14,104h27.71l7.46-18.63H211L218.48,104h28.26L204.38,8Zm.85,57.28,12.28-30.5,12.31,30.67Z"/>
              <polygon points="240.55 29.56 270.05 29.56 270.05 103.96 297.17 103.96 297.17 29.56 326.5 29.56 326.5 8.04 240.55 8.04 240.55 29.56"/>
              <path d="M406.47,36.16a23.27,23.27,0,0,1,8.46-5.53,28.83,28.83,0,0,1,10.83-1.93,26.68,26.68,0,0,1,12.37,2.85,33.8,33.8,0,0,1,10.32,8.39L465.64,24.3a46,46,0,0,0-17.5-13.44,58.05,58.05,0,0,0-23.76-4.64,58.78,58.78,0,0,0-21,3.64A47.85,47.85,0,0,0,375.56,36a53,53,0,0,0,0,40.16A48.44,48.44,0,0,0,386.6,92a49.06,49.06,0,0,0,16.74,10.31,59.37,59.37,0,0,0,21,3.44,57.4,57.4,0,0,0,23.76-4.71,47.37,47.37,0,0,0,17.5-13.37L448.45,72.05a33.51,33.51,0,0,1-10.32,8.39,26.57,26.57,0,0,1-12.37,2.86,29.64,29.64,0,0,1-10.83-1.89,23.5,23.5,0,0,1-8.46-5.57,26.2,26.2,0,0,1-5.47-8.7,32.81,32.81,0,0,1,0-22.49A26.22,26.22,0,0,1,406.47,36.16Z"/>
              <path d="M562.15,20.36A51,51,0,0,0,545.33,9.88a63.33,63.33,0,0,0-42.56,0,50.74,50.74,0,0,0-16.92,10.48,48.09,48.09,0,0,0-11.17,15.85,51.59,51.59,0,0,0,0,39.75,48.09,48.09,0,0,0,11.17,15.85,50.85,50.85,0,0,0,16.92,10.31,63.33,63.33,0,0,0,42.56,0,51.45,51.45,0,0,0,16.82-10.31A48.56,48.56,0,0,0,577.34,56a47.65,47.65,0,0,0-4.06-19.87A49.32,49.32,0,0,0,562.15,20.36Zm-14.2,47a26.61,26.61,0,0,1-5.5,8.7,23.54,23.54,0,0,1-8.22,5.57,28.52,28.52,0,0,1-20.42,0A23.72,23.72,0,0,1,505.59,76a26.28,26.28,0,0,1-5.5-8.7,33.36,33.36,0,0,1,0-22.56,26.26,26.26,0,0,1,5.5-8.62,23.56,23.56,0,0,1,8.22-5.54,28,28,0,0,1,20.42,0,23.2,23.2,0,0,1,8.22,5.54,26.26,26.26,0,0,1,5.5,8.62A32.89,32.89,0,0,1,548,67.33Z"/>
              <polygon points="656.28 59.16 613.96 8.04 591.61 8.04 591.61 103.96 618.19 103.96 618.19 52.84 660.54 103.96 682.89 103.96 682.89 8.04 656.28 8.04 656.28 59.16"/>
              <path d="M767.6,54.33A43.27,43.27,0,0,0,757,49.41q-5.81-1.84-11.65-3.09c-3.89-.82-7.47-1.62-10.7-2.41a25.14,25.14,0,0,1-7.8-3,5.59,5.59,0,0,1-3-5,6.91,6.91,0,0,1,1.51-4.4,10.34,10.34,0,0,1,4.92-3.06,28.52,28.52,0,0,1,9-1.17,48.66,48.66,0,0,1,13,1.86,63.31,63.31,0,0,1,13.76,5.54l8.35-20.15A58.38,58.38,0,0,0,758.25,8.3a80.31,80.31,0,0,0-18.6-2.14,57.72,57.72,0,0,0-23.55,4.23,33,33,0,0,0-14.2,11.25,27.23,27.23,0,0,0-4.74,15.64,24.39,24.39,0,0,0,3,12.68A24.62,24.62,0,0,0,708,58a45.38,45.38,0,0,0,10.62,5,104,104,0,0,0,11.66,3.16q5.81,1.25,10.62,2.48a26.83,26.83,0,0,1,7.84,3.16,6,6,0,0,1,1.41,9.25,11.07,11.07,0,0,1-5,2.72,32.78,32.78,0,0,1-9,1,55.75,55.75,0,0,1-16.81-2.68,61.5,61.5,0,0,1-14.85-6.88l-8.91,20a59.05,59.05,0,0,0,17.74,7.63A86.46,86.46,0,0,0,736,105.83a57.36,57.36,0,0,0,23.62-4.23,32.55,32.55,0,0,0,14.13-11.31,27.15,27.15,0,0,0,4.75-15.43,24.48,24.48,0,0,0-3-12.55A23.77,23.77,0,0,0,767.6,54.33Z"/>
              <path d="M853.38,59.44q0,12.35-4.78,17.67a19.32,19.32,0,0,1-26.64,0q-4.89-5.37-4.88-17.67V7.08H790V60.23q0,21.39,11.9,33T835,104.92q21.26,0,33.18-11.65t11.93-33V7.08H853.38Z"/>
              <polygon points="925.65 8.04 898.49 8.04 898.49 103.96 971.41 103.96 971.41 82.44 925.65 82.44 925.65 8.04"/>
              <polygon points="964.16 8.04 964.16 29.56 993.62 29.56 993.62 103.96 1020.75 103.96 1020.75 29.56 1050.11 29.56 1050.11 8.04 964.16 8.04"/>
            </svg>
          </NuxtLink>
        </div>
        <button class="block lg:hidden" @click="open = !open">
          <svg class="fill-primary w-4 h-4 scale-100 hover:scale-125 ease-in duration-200"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 20 20"
            aria-hidden="true" role="img">
            <title>Menu</title>
            <path v-show="open"
              d="M18.278 16.864a1 1 0 01-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 01-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 011.414-1.414l4.829 4.828 4.828-4.828a1 1 0 111.414 1.414l-4.828 4.829 4.828 4.828z" />
            <path v-show="!open"
              d="M4 5h16a1 1 0 010 2H4a1 1 0 110-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2z" />
          </svg>
        </button>
      </div>
      <ol id="menu" :class="[(open && 'opened'), ('list-image-none')]">
        <div v-for="item of menuItems.filter((item: MenuItem) => item.show)" :key="item.path">
          <li>
            <BaseLink :href="item.path" @click="item.click"
              :size="(['xl', '2xl'].includes(useNuxtApp()?.$styleSize?.value) ? useNuxtApp()?.$styleSize?.value : 'lg')"
              :disabled="item.disabled" :class-name="[
                'font-medium hover:text-slate-900',
                (!item.disabled && 'scale-100 hover:scale-[1.05] ease-in duration-200')
              ]">
              {{ item.title }}
            </BaseLink>
            <button v-if="item.items?.filter((subItem: MenuBase) => subItem.show)" class="text-slate-800"
              @click="openList[item.title] = !openList[item.title]">
              <svg
                class="fill-primary w-4 h-4 scale-100 hover:scale-125 ease-in duration-200"
                xmlns="http://www.w3.org/2000/svg"  xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 20 20"
                aria-hidden="true" role="img">
                <title>{{ item.title }}</title>
                <path v-show="openList[item.title]"
                  d="M18.278 16.864a1 1 0 01-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 01-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 011.414-1.414l4.829 4.828 4.828-4.828a1 1 0 111.414 1.414l-4.828 4.829 4.828 4.828z" />
                <path v-show="!openList[item.title]"
                  d="M4 5h16a1 1 0 010 2H4a1 1 0 110-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2z" />
              </svg>
            </button>
          </li>
          <BaseCollapse v-if="item.items?.filter((subItem: MenuBase) => subItem.show)" v-model="openList[item.title]"
            class="open:animate-[down-fade-in_400ms_ease-in-out]">
            <li v-for="subItem of item.items?.filter((subItem: MenuBase) => subItem.show)" :key="subItem.path">
              <BaseLink :href="subItem.path" @click="subItem.click"
                :size="(['xl', '2xl'].includes(useNuxtApp()?.$styleSize?.value) ? useNuxtApp()?.$styleSize?.value : 'lg')"
                :class-name="[
                  'font-normal hover:text-slate-900',
                  (!subItem.disabled && 'scale-100 hover:scale-[1.05] ease-in duration-200')
                ]" :disabled="subItem.disabled">
                {{ subItem.title }}
              </BaseLink>
            </li>
          </BaseCollapse>
        </div>
      </ol>
    </nav>
  </header>
</template>

<style lang="scss" scoped>
.navbar {
  @apply m-1 flex flex-col;
  @apply lg:flex-row lg:justify-between lg:items-center;

  >#logo {
    @apply flex flex-row justify-between items-center;
  }

  >#menu {
    @apply flex flex-col overflow-hidden;
    @apply lg:flex-row lg:gap-5 lg:overflow-visible;

    @apply max-h-0 transition-[max-height] duration-1000;
    @apply lg:max-h-screen lg:transition-none lg:duration-0;

    &.opened {
      @apply max-h-screen transition-[max-height] duration-[2000ms] ease-in-out;

      /* Desktop */
      /* max-height: 100vh;
          transition: max-height 2s ease-in-out; */
    }

    >div {
      @apply border-b lg:border-0;

      &:last-child {
        @apply border-0;

        li {
          &:last-child {
            @apply mb-0;
          }
        }
      }

      li {
        @apply flex justify-between gap-2 my-1 lg:my-0;

        a,
        button {
          @apply p-0 px-1;
        }
      }

      &:last-child>li {
        @apply mb-0;
      }
    }
  }
}
</style>
